import {COUNTRIES as COUNTRY_OPTIONS} from '@code-dot-org/core/constants';

import {UsStates} from '@cdo/generated-scripts/sharedConstants';

export const STATE_CODES = Object.keys(UsStates).sort();

export const STATES = [
  '',
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Washington DC',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

// Note that this array is returned sorted by country name, not abbreviation.
export const COUNTRIES = COUNTRY_OPTIONS.map(({value, text}) => ({
  label: value,
  value: text,
})).sort((a, b) => a.value.localeCompare(b.value));
